import type { FileDownloadFormat } from './utils/file';

/** Форматы, в которых система отдаёт скачиваемый документ, в порядке показа */
export const DOWNLOAD_FORMATS: FileDownloadFormat[] = ['docx', 'xlsx', 'pdf'];

/**
 * Оформление лейбла формата: цвет отличает форматы друг от друга. Классами, а не вариантом
 * лейбла: нужных сигнальных вариантов в общей библиотеке нет. Перечень и оформление лежат
 * в общем слое, чтобы формат выглядел одинаково, откуда бы его ни выбирали.
 */
export const DOWNLOAD_FORMAT_BADGE_CLASS: Record<FileDownloadFormat, string> = {
  docx: 'bg-primary/5 text-primary border-primary',
  xlsx: 'bg-success text-success-foreground border-success-border',
  pdf: 'bg-warning text-warning-foreground border-warning-border',
};
